import { styled } from '@mui/material';

export const ContentW = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 671px;
  margin: 0 auto;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;
